import React from "react";
import { ReactComponent as FailureIcon } from "src/assets/icons/payment-failure.svg";
import PaymentBackButton from "./PaymentBackButton";
import "./payment.scss";
import HorizontalDivider from "src/components/HorizontalDivider/HorizontalDivider";
import { useTranslation } from "react-i18next";
const PaymentFail = () => {

  const { t } = useTranslation(["invoice"]);

  return (
    <div className="d-flex flex-column gap-2 p-4 payment-failure">
      <div className="payment-content">
        <div className="top-content d-flex flex-column justify-content-center align-items-center w-100">
          <FailureIcon className="payment-top-icon" />
          <h5>{t("paymentFailed")}</h5>
          <div className="mb-3">
            <span>
              {t("somethingWentWrong")}
            </span>
          </div>
        </div>
        <HorizontalDivider />
        <div className="mt-3">
          <PaymentBackButton />
        </div>
      </div>
    </div>
  );
};

export default PaymentFail;
